import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ProjectManagerListModalComponent } from 'src/app/Modules/idms/components/project-manager/modals/project-manager-list-modal/project-manager-list-modal.component';
import { AllowedItem } from 'src/app/Modules/settings/models/informate/allowed-item';
import { AllowedItemType } from 'src/app/Modules/settings/models/informate/allowed-item-type';

@Component({
    selector: 'app-instance-conf-sidebar-data',
    templateUrl: './instance-conf-sidebar-data.component.html',
    styleUrls: ['./instance-conf-sidebar-data.component.scss'],
})
export class InstanceConfSidebarDataComponent {
    @Input()
    set items(value: any) {
        if (value !== null && value !== undefined) {
            this._items = { ...value };
            if (value.items && value.items.length > 5) {
                this.itemsCopyDisplay = { ...value, items: value.items.slice(0, 5) };
            } else {
                this.itemsCopyDisplay = { ...value };
            }
        }
    }
    get items() {
        return { ...this._items };
    }

    @Input() level: number;
    @Output() selectedItemlevel: EventEmitter<any> = new EventEmitter<any>();

    _items: AllowedItemType;
    itemsCopyDisplay: any = {};
    searchInput: string;
    selectedItem: AllowedItem;

    constructor(private model: NgbModal) {}

    itemSelected(item) {
        if (item?.items) {
            this.selectedItemlevel.emit({ item, level: this.level });
            this.selectedItem = item;
        }
    }

    clickMore() {
        let dialogRef = this.model.open(ProjectManagerListModalComponent, {
            windowClass: 'custom-modal',
        });
        dialogRef.componentInstance.projectsList = this._items.items;
        dialogRef.componentInstance.currentInstance = this._items.name;
        dialogRef.componentInstance.type = 'instance-conf-sidebar';

        dialogRef.result.then((resp: any) => {
            if (resp) {
                this.selectedItemlevel.emit({ item: resp, level: this.level });
                this.selectedItem = resp;
                let index = this._items.items.findIndex((x) => x == resp);
                if (index >= -1) {
                    if (index >= 4) {
                        this.itemsCopyDisplay.items.pop();
                        this.itemsCopyDisplay.items.unshift(resp);
                    }
                }
            }
        });
    }

    searchResult(event): void {
        if (this.searchInput.trim() !== '') {
            this.itemsCopyDisplay.items = this._items.items.filter((item) => {
                return (item.name !== undefined ? item.name : '').toLowerCase().includes(this.searchInput.trim().toLowerCase());
            });
        } else {
            this.itemsCopyDisplay.items = [...this._items.items];
        }
        this.itemsCopyDisplay.items.splice(5);
    }
}
